<!--
 * @Author: M.D.
 * @Date: 2020-01-16 10:07:20
 * @LastEditors: M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="invoice-o-w">
    <el-dialog
      class="invoice"
      ref="invoiceDialog"
      width="36%"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
    <!-- title -->
    <div class="invo-header" slot="title">
      开具发票
    </div>
    <!-- type-change -->
    <div class="invo-type-w">
      <span class="inv-type-btn" @click="typeChg(1)" :class="{'active':vAddForm.invoiceType===1}">普通电子发票</span>
      <span class="inv-type-btn" @click="typeChg(2)" v-show="false" :class="{'active':vAddForm.invoiceType===2}">增值税专用票</span>
    </div>
    <!-- info -->
    <el-alert :closable="false"
      title="发票内容将显示详细商品名称与价格信息，发票金额为实际支付金额，具体请以展示为准"
      type="warning">
    </el-alert>

    <!-- 电子发票 -->
    <div class="invo-e-form-w" v-if="vAddForm.invoiceType === 1">
      <el-form ref="eInvForm" :model="vAddForm" label-position="right"  label-width="140px">
          <!-- 电子-type -->
          <el-form-item label="发票抬头：" prop="invoiceRiseType" required>
            <el-radio-group @change="onRadioGroupChange" v-model="vAddForm.invoiceRiseType">
              <el-radio :label="0" >个人</el-radio>
              <el-radio :label="1" >企业</el-radio>
              <el-radio :label="2" >事业单位</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 电子-个人-1 -->
          <div class="e-inv-gr"
            style="max-width:440px"
            v-if="vAddForm.invoiceRiseType === 0">
            <el-form-item label="抬头名称：" prop="enterpriseName" :rules="rule.companyName">
              <el-input placeholder="请输入抬头名称" v-model="vAddForm.enterpriseName"></el-input>
            </el-form-item>
            <el-form-item label="收票人邮箱：" prop="mailbox" :rules="rule.email">
              <el-input placeholder="请输入收票人邮箱" v-model="vAddForm.mailbox"></el-input>
            </el-form-item>
          </div>

          <!-- 电子-企业-2 -->
          <div class="e-inv-qy"
            style="max-width:440px;"
            v-if="vAddForm.invoiceRiseType === 1">
            <el-form-item label="企业名称：" prop="enterpriseName" :rules="rule.companyName">
              <el-input placeholder="请输入企业名称" v-model="vAddForm.enterpriseName"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号：" prop="taxpayerNumber" :rules="rule.taxpayerNumberRequired">
              <el-input placeholder="请输入纳税人识别号" v-model="vAddForm.taxpayerNumber"></el-input>
            </el-form-item>
            <el-form-item label="收票人邮箱：" prop="mailbox" :rules="rule.email">
              <el-input placeholder="请输入收票人邮箱" v-model="vAddForm.mailbox"></el-input>
            </el-form-item>
          </div>

          <!-- 电子-事业单位-3 -->
          <div class="e-inv-sy" style="max-width:440px;" v-if="vAddForm.invoiceRiseType === 2">
            <el-form-item label="单位名称：" prop="enterpriseName" :rules="rule.companyName">
              <el-input placeholder="请输入单位名称" v-model="vAddForm.enterpriseName"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号：" prop="taxpayerNumber" :rules="rule.taxpayerNumberNotRequired">
              <el-input placeholder="请输入纳税人识别号" v-model="vAddForm.taxpayerNumber"></el-input>
            </el-form-item>
            <el-form-item label="收票人邮箱：" prop="mailbox" :rules="rule.email">
              <el-input placeholder="请输入收票人邮箱" v-model="vAddForm.mailbox"></el-input>
            </el-form-item>
          </div>

      </el-form>
    </div>

    <!-- 增值税 -->
    <div class="invo-v-form-w" v-if="vAddForm.invoiceType === 2" style="max-width:440px">
      <el-form ref="vAddForm" label-position="right" :model="vAddForm" label-width="140px">
        <el-form-item label="发票抬头：" prop="enterpriseName" :rules="rule.companyName">
          <el-input placeholder="请输入发票抬头" v-model="vAddForm.enterpriseName"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号：" prop="taxpayerNumber" :rules="rule.taxpayerNumberRequired">
          <el-input placeholder="请输入纳税人识别号" v-model="vAddForm.taxpayerNumber"></el-input>
        </el-form-item>
        <el-form-item label="开户银行：" prop="bank" :rules="bank">
          <el-input placeholder="请输入开户银行名称" v-model="vAddForm.bank"></el-input>
        </el-form-item>
        <el-form-item label="银行账号：" prop="bankNumber" :rules="bankNumber">
          <el-input placeholder="请输入银行账号" v-model="vAddForm.bankNumber"></el-input>
        </el-form-item>
        <el-form-item label="企业地址：" prop="enterpriseAddress" :rules="enterpriseAddress">
          <el-input placeholder="请输入企业地址" v-model="vAddForm.enterpriseAddress"></el-input>
        </el-form-item>
        <el-form-item label="企业电话：" prop="enterpriseMobile" :rules="enterpriseMobile">
          <el-input placeholder="请输入企业电话" v-model="vAddForm.enterpriseMobile"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- btns -->
    <div slot="footer" class="invo-footer">
      <el-button @click="submit" type="primary">确定</el-button>
    </div>

    </el-dialog>
  </div>
</template>

<script>
import API from '@/api/ord-api'
import rule from '@/util/rule'
import { mapGetters } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      rule,
      showDialog: this.show,
      // 增值税
      vAddForm: {
        bank: '',
        bankNumber: '',
        collectInvoiceMobile: '',
        enterpriseAddress: '',
        enterpriseMobile: '',
        enterpriseName: '',  //发票抬头，企业名称
        id: this.orderId,
        invoiceRise: '', //发票抬头
        invoiceRiseType: 0, // 0个人 1单位 2事业单位
        invoiceType: 1, // 1电子普通发票，2增值税专票
        mailbox: '',
        taxpayerNumber: ''
      },
      bank: {
        required: true,
        validator: (rule, value, cb) => {
          const reg = /^.{1,50}$/
          if (!value) {
            return cb(new Error('银行不能为空'))
          } else if (!reg.test(value)) {
            return cb(new Error('请输入1-50位字符'))
          } else {
            cb()
          }
        }
      },
      bankNumber: {
        required: true,
        validator: (rule, value, cb) => {
          const reg = /^.{1,30}$/
          if (!value) {
            return cb(new Error('银行账号不能为空'))
          } else if (!reg.test(value)) {
            return cb(new Error('请输入1-30位字符'))
          } else {
            cb()
          }
        }
      },
      enterpriseAddress: {
        required: true,
        validator: (rule, value, cb) => {
          const reg = /^.{1,100}$/
          if (!value) {
            return cb(new Error('企业地址不能为空'))
          } else if (!reg.test(value)) {
            return cb(new Error('请输入1-100位字符'))
          } else {
            cb()
          }
        }
      },
      enterpriseMobile: {
        required: true,
        validator: (rule, value, cb) => {
          const reg = /(^(\d{3,4}-)?\d{7,8})$|(1[0-9][0-9]{9})/
          if (!value) {
            return cb(new Error('企业电话不能为空'))
          } else if (!reg.test(value)) {
            return cb(new Error('请输入电话号码'))
          } else {
            cb()
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['memberInfo'])
  },
  created () {
    this.getInvoiceInfo(1)
  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {
    show (v) {
      this.showDialog = v
    }
  },
  methods: {
    onRadioGroupChange (v) {
      this.vAddForm.invoiceRiseType = v
      this.getInvoiceInfo(1)
    },
    handleClose (done) {
      this.$emit('visibleUpdate', false)
      done()
    },
    async submit () {
      if (this.vAddForm.invoiceType === 1) {
        this.submitA()
      } else {
        this.submitB()
      }
    },
    submitB () {
      this.$refs.vAddForm.validate(async valid => {
        if (valid) {
          if (this.orderId !== '') {
            this.vAddForm.id = this.orderId
            this.vAddForm.invoiceRiseType = -1
            const res = await API.supplementInvoice(this.vAddForm)
            if (res.data.statusCode === '200') {
              this.$message({
                type: 'success',
                message: res.data.message
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
            this.$emit('visibleUpdate', false)
          } else {
            this.vAddForm.invoiceRiseType = -1
            // if (this.validateForm()) {
            //   this.$emit('invoiceVal', this.getFormData(this.vAddForm.invoiceType, this.vAddForm.invoiceRiseType))
            // } else {
            //   this.$alert('发票项目填写有误，请检查！', '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {
            //       console.log('')
            //     }
            //   })
            //   return
            // }
            // 将所有参数通过事件传递到外部
            this.$emit('savedInvoceInfo', this.vAddForm)
          }
        }
      })
    },
    submitA () {
      this.$refs.eInvForm.validate(async valid => {
        if (valid) {
          if (this.orderId !== '') {
            this.vAddForm.id = this.orderId
            const res = await API.supplementInvoice(this.vAddForm)
            if (res.data.statusCode === '200') {
              this.$message({
                type: 'success',
                message: res.data.message
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
            this.$emit('visibleUpdate', false)
          } else {
            // if (this.validateForm()) {
            //   this.$emit('invoiceVal', this.getFormData(this.vAddForm.invoiceType, this.vAddForm.invoiceRiseType))
            // } else {
            //   this.$alert('发票项目填写有误，请检查！', '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {
            //       console.log('')
            //     }
            //   })
            // }

            // 将所有参数通过事件传递到外部
            this.$emit('savedInvoceInfo', this.vAddForm)
          }
        }
      })
    },
    typeChg (v) {
      // 去掉红色未通过验证提示
      if (v === 1) {
        this.$refs.vAddForm.clearValidate()
        this.vAddForm.invoiceRiseType = 0
      } else {
        this.$refs.eInvForm.clearValidate()
      }

      // 从网络获取已有信息
      this.getInvoiceInfo(v)
    },

    async getInvoiceInfo (v) {
      // v=1 普通电子发票 v=2 增值税专用票
      const invoRes = await API.getInvoiceInfo({
        invoiceType: v,
        // 当invoiceType=1时（invoiceRiseType 0个人 1单位 2事业单位）
        // 当invoiceType=2时（invoiceRiseType=-1）
        invoiceRiseType: (v === 1) ? this.vAddForm.invoiceRiseType : -1,
        memberId: this.memberInfo.id
      })

      if (invoRes.data.statusCode === '200' && invoRes.data.result) {
        this.vAddForm = invoRes.data.result
      }
      // console.log(this.vAddForm)
      this.vAddForm.invoiceType = v
      this.vAddForm.invoiceRise='' //弃用该字段
    },

    getFormData (t, r) {
      const form = this.vAddForm
      let arr = ['invoiceRiseType', 'invoiceType']
      if (t === 1 && r === 0) { //个人
        arr = arr.concat(['enterpriseName', 'mailbox'])
      } else if (t === 1 && r === 1) { //企业
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'mailbox'])
      } else if (t === 1 && r === 2) {   //事业单位
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'mailbox'])
      } else if (t === 2) { //专票
        arr = arr.concat(['invoiceRise', 'taxpayerNumber', 'bank', 'bankNumber', 'enterpriseAddress', 'enterpriseMobile'])
      }
      this._.mapKeys(form, (value, key) => {
        if (!this._.includes(arr, key)) {
          form[key] = ''
        }
      })
      return form
    },
    validateForm () {
      const form = this.vAddForm
      let re = true
      const t = this.vAddForm.invoiceType; const r = this.vAddForm.invoiceRiseType
      let arr = []
     if (t === 1 && r === 0) { //个人
       arr = arr.concat(['enterpriseName', 'mailbox'])
     } else
      if (t === 1 && (r === 1 )) { //企业
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'mailbox'])
      } else if (t === 1 && r === 2) { //事业
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'mailbox'])
      } else if (t === 2) { //专票
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'bank', 'bankNumber', 'enterpriseAddress', 'enterpriseMobile'])
      }
      this._.forIn(form, (value, key) => {
        if (this._.includes(arr, key) && re) {
          if (form[key] === '') {
            re = false
          }
        }
      })
      return re
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.invoice-o-w
  .invoice
    .invo-type-w
      height 46px
      .inv-type-btn
        display inline-block
        padding 8px 16px
        margin 0 10px
        border 1px solid theme-color
        color theme-color
        background-color theme-color-light
        &.active
          color theme-color-light
          background-color theme-color
    .invo-e-form-w
      margin-top 10px
      .el-form-item
        margin-bottom 20px
    .invo-v-form-w
      margin-top 10px
</style>
